import { render, staticRenderFns } from "./VideojsMarkersPlayer.vue?vue&type=template&id=f6395b28&scoped=true"
import script from "./VideojsMarkersPlayer.vue?vue&type=script&lang=js"
export * from "./VideojsMarkersPlayer.vue?vue&type=script&lang=js"
import style0 from "./VideojsMarkersPlayer.vue?vue&type=style&index=0&id=f6395b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6395b28",
  null
  
)

export default component.exports